import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Link,
  Popover,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import CommonTable from "../Common/Components/CommonTable";
import CardLayout from "../Common/Components/CardLayout";
import Input from "../Common/Components/InputField";
import { useForm } from "react-hook-form";
import PdfIcon from "../assets/pdfIcon.svg";
import ExcelIcon from "../assets/excelIcon.svg";
import loadergif from "../assets/loader.gif";
import {
  getOverViewData,
  ticketListData,
  getDashboardFilesData,
  getIntellectStatus,
  getState,
} from "../apiSection/apiUrlConstent";
import service from "../apiSection/service";
import { useSelector } from "react-redux";
import CustomModal from "../Common/Components/modal";
import TicketHistory from "./TicketHistory";
import "jspdf-autotable";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { DateRangePicker, DateRange } from "mui-daterange-picker";
import { ShowAlert } from "../Common/Components/Alert";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import Loading from "../Common/Components/Loading";
import { useTranslation } from "react-i18next";
import CustomSelect from "../Common/Components/Select";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import InfoIcon from '@mui/icons-material/Info';

function mergeArrays(array1, array2) {
  return array1.map((item1) => {
    const match = array2.find((item2) => item2.status === item1.status);

    return {
      ...item1,
      count: match ? match.count : 0,
      Status_desc: match ? match.Status_desc : "Unknown",
    };
  });
}

function Dashboard(props) {
  const { register, control } = useForm();
  const { t, i18n } = useTranslation("common");
  const userData = useSelector((state) => state.auth.user);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [rowData, setRowData] = useState({});
  const [stateId, setStateId] = useState("");
  const [paginationData, setPaginationData] = useState({
    pageNo: 0,
    size: 10,
    search: false,
    searchVal: "",
  });
  const [isDownloadRequired, setIsDownloadRequired] = useState(true);

  const [filters, setFilters] = useState({
    search_string: "",
    status: 0,
    sort_by: "",
    sort_order: "",
    start_date: "",
    end_date: "",
    state_id: 0,
  });
  const [searchValue, setSearchValue] = useState("");
  const [tableData, setTableData] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);
  const [selectedCard, setSelectedCard] = useState(0);
  const [loading, setLoading] = useState(false);

  const labelMap = {
    attachment: "Attachment",
    created_by: "Created By",
    created_on: "Created On",
    dccb_code: "DCCB Code",
    dct_id: "DCT ID",
    department_desc: "Department",
    erp_id: "ERP ID",
    expiretime: "Expiration Time",
    file_extension: "File Extension",
    file_name: "File Name",
    modified_by: "Modified By",
    modified_on: "Modified On",
    module_desc: "Module",
    pac_id: "PAC ID",
    reason: "Reason",
    severity_desc: "Severity",
    state_code: "State Code",
    status_desc: "Status",
    sub_desc: "Subject",
    task_desc: "Task",
    tckt_assigned_to: "Ticket Assigned To",
    tckt_desc: "Ticket Description",
    tckt_id: "Ticket ID",
    intellect_ticket_no: "Intellect Number",
    // tckt_status: "Ticket Status",
  };
  let removedkeys = [
    "created_by",
    "tckt_assigned_to",
    "tckt_status",
    "file_name",
    "file_extension",
  ];
  let excetRemovedColumn = [
    "tckt_desc",
    "sub_desc",
    "file_name",
    "file_extension",
    "attachment",
    "tckt_status",
    "tckt_assigned_to",
    "created_by",
    "created_on",
    "modified_by",
    "modified_on",
    "dct_id",
    "state_code",
    "module_desc",
    "department_desc",
    "task_desc",
    "reason",
    "expiretime",
    "intellect_encrypted_id",
    "intellect_id",
  ];
  let cardData = [];
  const getCardData = (role_id, t) => {
    switch (true) {
      case role_id === 3:
        return [
          { label: "Total Tickets", bg: "#EEF4FE", status: 0 },
          { label: "Open Tickets", bg: "#E7F6FC", status: 1 },
          { label: "Tickets Reassigned", bg: "#FEE7E7", status: 4 },
          { label: "Tickets With Intellect", bg: "#EEF4FE", status: 7 },
          { label: "Re-open", bg: "#FFF4E6", status: 8 },
          { label: "Overdue", bg: "#E7F6FC", status: 5 },
          { label: "Overdue-Intellect", bg: "#FFF4E6", status: 9 },
          { label: "Intellect-Reopen", bg: "#FEE7E7", status: 10 },
          { label: "Resolved Tickets", bg: "#FFF4E6", status: 2 },
          { label: "Closed Tickets", bg: "#DDFCE0", status: 3 },
          {
            label: "Intellect Resolved",
            bg: "#FEE7E7",
            status: 11,
            icon: <InfoIcon />
          }
        ];

      case [8, 9, 10].includes(role_id):
        return [
          { label: "Total Tickets", bg: "#EEF4FE", status: 0 },
          { label: "Open Tickets", bg: "#E7F6FC", status: 1 },
          { label: "Tickets Reassigned", bg: "#FEE7E7", status: 4 },
          { label: "Tickets With Intellect", bg: "#EEF4FE", status: 7 },
          { label: "Re-open", bg: "#FFF4E6", status: 8 },
          { label: "Overdue", bg: "#E7F6FC", status: 5 },
          { label: "Overdue-Intellect", bg: "#FFF4E6", status: 9 },
          { label: "Intellect-Reopen", bg: "#FEE7E7", status: 10 },
          { label: "Resolved Tickets", bg: "#FFF4E6", status: 2 },
          { label: "Closed Tickets", bg: "#DDFCE0", status: 3 },
          {
            label: "Intellect Resolved",
            bg: "#FEE7E7",
            status: 11,
            icon: <InfoIcon />
          }
        ];

      case role_id === 1:
        return [
          { label: t("totalTickets"), bg: "#EEF4FE", status: 0 },
          { label: t("openTickets"), bg: "#E7F6FC", status: 1 },
          { label: t("ticketsReassigned"), bg: "#FEE7E7", status: 4 },
          { label: t("ticketsWithIntellect"), bg: "#EEF4FE", status: 7 },
          { label: t("reopen"), bg: "#FFF4E6", status: 8 },
          { label: t("overdue"), bg: "#E7F6FC", status: 5 },
          { label: t("overdueIntellect"), bg: "#FFF4E6", status: 9 },
          { label: t("intellectReopen"), bg: "#FEE7E7", status: 10 },
          { label: t("resolvedTickets"), bg: "#FFF4E6", status: 2 },
          { label: t("closedTickets"), bg: "#DDFCE0", status: 3 },
          {
            label: t("intellectResolved"),
            bg: "#FEE7E7",
            status: 11,
            icon: <InfoIcon />
          }
        ];

      case role_id === 11:
        return [
          { label: "Total Tickets", bg: "#EEF4FE", status: 0 },
          { label: "Open Tickets", bg: "#E7F6FC", status: 1 },
          { label: "Tickets Reassigned", bg: "#FEE7E7", status: 4 },
          { label: "Tickets With Intellect", bg: "#EEF4FE", status: 7 },
          { label: "Re-open", bg: "#FFF4E6", status: 8 },
          { label: "Overdue", bg: "#E7F6FC", status: 5 },
          { label: "Overdue-Intellect", bg: "#FFF4E6", status: 9 },
          { label: "Intellect-Reopen", bg: "#FEE7E7", status: 10 },
          { label: "Resolved Tickets", bg: "#FFF4E6", status: 2 },
          { label: "Closed Tickets", bg: "#DDFCE0", status: 3 },
          {
            label: "Intellect Resolved",
            bg: "#FEE7E7",
            status: 11,
            icon: <InfoIcon />
          }
        ];

      default:
        return [
          { label: "Total Tickets", bg: "#EEF4FE", status: 0 },
          { label: "Open Tickets", bg: "#E7F6FC", status: 1 },
          { label: "Tickets Reassigned", bg: "#FEE7E7", status: 4 },
          { label: "Tickets With Intellect", bg: "#EEF4FE", status: 7 },
          { label: "Re-open", bg: "#FFF4E6", status: 8 },
          { label: "Overdue", bg: "#E7F6FC", status: 5 },
          { label: "Overdue-Intellect", bg: "#FFF4E6", status: 9 },
          { label: "Intellect-Reopen", bg: "#FEE7E7", status: 10 },
          { label: "Resolved Tickets", bg: "#FFF4E6", status: 2 },
          { label: "Closed Tickets", bg: "#DDFCE0", status: 3 },
          {
            label: "Intellect Resolved",
            bg: "#ffd1b3",
            status: 11,
            icon: <InfoIcon />
          }
        ];
    }
  };
  const columns = [
    // { id: "sNo", label: "S. No", align: "left" },
    { id: "tckt_id", label: "Ticket ID", align: "left" },
    { id: "dccb_code", label: "DCCB", align: "left" },
    { id: "district", label: "District", align: "left" },
    {
      id: "pac_id",
      label: "PACS ID",
      align: "left",
    },
    // { id: "module_desc", label: "Module", align: "left" },
    { id: "department_desc", label: "Department Type", align: "left" },
    { id: "intellect_ticket_no", label: "Intellect", align: "left" },

    { id: "created_on", label: "Created Date", align: "left" },
    { id: "severity_desc", label: "Severity", align: "left" },
    { id: "tckt_status", label: "Status", align: "left" },
    { id: "refreshicon", label: "", align: "left" },
  ];
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [bounce, setBounce] = useState(null);
  const [render, setRender] = useState(false);
  const [stateData, setStateData] = useState("");
  useEffect(() => {
    getOverViewDatafn();
    handleStateData();
  }, [currentPage]);

  const getOverViewDatafn = (updatedStateId) => {
    const postData = {
      state_id: updatedStateId || 0, // Use optional chaining and default value
    };
    service
      .create(getOverViewData, postData)
      .then((res) => {
        let mergedData = mergeArrays(cardData, res.data.result);
        setData(mergedData);
      })
      .catch((error) => {
        console.error("Error fetching overview data:", error); // Log the error for debugging
      });
  };
  const handleCreateTicket = () => {
    props.Redirectpath("/dashboard/createTicket");
  };
  function decryptAndTransformAttachment(data) {
    try {
      // Initialize arrays for transformed attachments
      let transformedAttachments = [];
      let transformedUpdatedAttachments = [];

      // Handle 'attachment' field (decode and transform it)
      if (data.attachment) {
        try {
          // Decode the Base64-encoded 'attachment'
          const decodedAttachment = atob(data.attachment);
          // Parse the JSON string to an array of objects
          const attachmentArray = JSON.parse(decodedAttachment);
          // Transform the 'attachment' array
          transformedAttachments = attachmentArray.map((file) => ({
            ...file,
            newName: `${file.name}.${file.extension}`, // Create a unique new name
          }));
        } catch (error) {
          console.error(
            "Error while decoding or transforming 'attachment':",
            error
          );
          transformedAttachments = []; // Set to empty array if error occurs
        }
      }

      // Handle 'updated_attachment' field (decode and transform it)
      if (data.updated_attachment) {
        try {
          // Decode the Base64-encoded 'updated_attachment'
          const decodedUpdatedAttachment = atob(data.updated_attachment);
          // Parse the JSON string to an array of objects
          const updatedAttachmentArray = JSON.parse(decodedUpdatedAttachment);
          // Transform the 'updated_attachment' array
          transformedUpdatedAttachments = updatedAttachmentArray.map(
            (file) => ({
              ...file,
              newName: `${file.name}.${file.extension}`, // Create a unique new name
            })
          );
        } catch (error) {
          console.error(
            "Error while decoding or transforming 'updated_attachment':",
            error
          );
          transformedUpdatedAttachments = []; // Set to empty array if error occurs
        }
      }

      // Return a new object with the transformed attachments and original data
      return {
        ...data, // Spread the original object
        decryptedAttachment: transformedAttachments, // Add transformed 'attachment'
        decryptedUpdatedAttachment: transformedUpdatedAttachments, // Add transformed 'updated_attachment'
      };
    } catch (error) {
      console.error(
        "Error while decrypting and transforming attachments:",
        error
      );
      // Return the original data as fallback if something goes wrong
      return {
        ...data,
        decryptedAttachment: [],
        decryptedUpdatedAttachment: [],
      };
    }
  }

  const handleRowClick = (data, key) => {
    setRowData(decryptAndTransformAttachment(data));
    if (key == "details") {
      setDetailsOpen(true);
    } else if (key == "refresh") {
      handleRefreshIntellectStatus(data.tckt_id);
    }
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;

    // Update the search value
    setSearchValue(searchValue);

    // Clear any existing timeout
    clearTimeout(bounce);

    // Set a new timeout for debouncing
    let temp_bounce = setTimeout(() => {
      // Update the filters with the search string
      setFilters((data) => ({
        ...data,
        search_string: searchValue,
      }));
    }, 300);

    // Save the timeout ID
    setBounce(temp_bounce);
  };

  const removeKeysFromArray = (dataArray, keysToRemove) => {
    return dataArray.map((item) => {
      const filteredItem = { ...item }; // Create a shallow copy to avoid modifying original objects
      keysToRemove.forEach((key) => {
        delete filteredItem[key];
      });
      return filteredItem;
    });
  };
  const handleClose = () => {
    setDetailsOpen(false);
    setRowData({});
    setRender(!render);
    getOverViewDatafn();
  };
  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };
  const handleCardData = (e, itemData) => {
    setSelectedCard(itemData.status);
    setFilters((data) => {
      return { ...data, status: itemData.status };
    });
  };
  const [open, setOpen] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRange, setSelectedRange] = useState(null);
  const [hover, setHover] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose1 = () => {
    setOpen(false);
  };

  const handleDateChange = (range) => {
    setSelectedRange(range);
  };

  const handleSave = () => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // Formats as YYYY-MM-DD
    };

    if (selectedRange) {
      const { startDate, endDate } = selectedRange;

      if (!startDate || !endDate) {
        setSnackBarMessage("Inavlid Dates");
        setOpenSnackBar(true);
      } else {
        setFilters((data) => ({
          ...data,
          start_date: formatDate(startDate),
          end_date: formatDate(endDate),
        }));
        handleClose();
        handleClose1();
      }
    } else {
      setSnackBarMessage("Please select both start and end dates to proceed.");
      setOpenSnackBar(true);
    }
  };
  const handleReset = () => {
    setSelectedRange(null);
    setFilters((data) => ({
      ...data,
      start_date: null,
      end_date: null,
    }));
    handleClose1();
  };
  const handleRefreshIntellectStatus = (id) => {
    setLoading(true);
    let postObj = {
      tckt_id: id,
    };
    service
      .create(getIntellectStatus, postObj)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setRender(!render);
          ShowAlert({
            icon: "success",
            text: res.data.message,
            width: "400px",
            confirmAction: () => { },
          });
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);

        ShowAlert({
          icon: "error",
          text: "Network Error",
          width: "400px",
        });
      });
  };

  const handleStateData = () => {
    setLoading(true);
    service
      .get(getState)
      .then((res) => {
        setLoading(false);
        setStateData(res.data.result.list_state);
        console.log(stateData, "tom");
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const handleStateFilter = (data) => {
    setFilters({
      search_string: "",
      status: 0,
      sort_by: "",
      sort_order: "",
      start_date: "",
      end_date: "",
      state_id: data.id,
    });
    setStateId(data.id);
    getOverViewDatafn(data.id);
  };
  const getTicketStyles = (tckt_status) => {
    let color, background;

    switch (tckt_status) {
      case 1:
        color = "#2196f3"; // Blue
        background = "#e3f2fd"; // Light Blue
        break;
      case 2:
        color = "#FE9003"; // Orange
        background = "#FE90031A"; // Light Orange with Transparency
        break;
      case 3:
        color = "#4caf50"; // Green
        background = "#e8f5e9"; // Light Green
        break;
      case 4:
        color = "#C7004C"; // Red
        background = "#C7004C1A"; // Light Red with Transparency
        break;
      case 5:
        color = "#FF4646"; // Light Red
        background = "#FF46461A"; // Light Red with Transparency
        break;
      case 6:
        color = "#C7004C"; // Red
        background = "#C7004C1A"; // Light Red with Transparency
        break;
      case 7:
        color = "#393091"; // Dark Blue
        background = "#3930911A"; // Transparent Dark Blue
        break;
      case 8:
        color = "#393091"; // Dark Blue
        background = "#3930911A"; // Transparent Dark Blue
        break;
      case 9:
        color = "#FF4646"; // Dark Blue
        background = "#FF46461A"; // Transparent Dark Blue
        break;
      case 10:
        color = "#393091"; // Dark Blue
        background = "#3930911A"; // Transparent Dark Blue
        break;
      case 11:
        color = "#393091";
        background = "#3930911A";
        break;
      default:
        color = "transparent"; // Default Color
        background = "black"; // Default Background
        break;
    }

    return { color, background };
  };
  const [cardPage, setCardPage] = useState(0); // Start with the first card
  const itemsPerPage = 4; // Display 4 cards at a time

  const handleNext = () => {
    if (cardPage + itemsPerPage < data.length) {
      setCardPage(cardPage + 1); // Increment cardPage by 1
    }
  };

  const handlePrev = () => {
    if (cardPage > 0) {
      setCardPage(cardPage - 1); // Decrement cardPage by 1
    }
  };
  const downloadExcel = (data) => {
    setOpenXlfile((dt) => {
      return { open: false };
    });
    if (data?.file_url) {
      let newWindow = window.open(data.file_url, "__blank");
    }

    return;
  };

  const sendJsonAndDownloadPdf = (data) => {
    setOpenPdfFile((data) => {
      return { ...data, open: false };
    });
    if (data?.file_url_pdf) {
      let newWindow = window.open(data.file_url_pdf, "__blank");
    }
    // else if (dashboardData.file_url_pdf)
    // window.open(dashboardData.file_url_pdf, "__blank");
    console.log(JSON.stringify(openPdfFile));
    setTimeout(() => {
      setOpenPdfFile((data) => {
        return { ...data, open: false };
      });
    }, 300);

    return;
  };
  const [openXlfile, setOpenXlfile] = useState({ open: false });
  const [openPdfFile, setOpenPdfFile] = useState({ open: false });
  const [customFilter, setCustomFilter] = useState(null);
  const [downloadfies, setDownloadfies] = useState({
    file_url_pdf: "",
    file_url: "",
  });
  useEffect(() => {
    setDownloadfies({ file_url_pdf: "", file_url: "" });
  }, [customFilter]);

  const getPdfFilesData = (callfrom = "download_excel") => {
    if (callfrom == "download_excel") {
      if (downloadfies?.file_url != "") {
        downloadExcel(downloadfies);

        return;
      }
    } else if (callfrom == "download_pdf") {
      if (downloadfies?.file_url_pdf != "") {
        sendJsonAndDownloadPdf(downloadfies);

        return;
      }
    }

    let post_data = { ...filters, page: 1, per_page: 25 };
    post_data["file_category"] = callfrom;
    service
      .create(getDashboardFilesData, post_data)
      .then((response) => {
        if (
          response?.data?.result?.file_url_pdf ||
          response?.data?.result?.file_url
        ) {
          setDownloadfies((data) => {
            let temp_data = { ...data };
            if (response?.data?.result?.file_url_pdf) {
              temp_data["file_url_pdf"] = response?.data?.result?.file_url_pdf;
            }
            if (response?.data?.result?.file_url) {
              temp_data["file_url"] = response?.data?.result?.file_url;
            }
            return temp_data;
          });
        }

        if (response?.data?.result?.file_category == "download_excel") {
          setOpenXlfile((dt) => {
            return { open: false };
          });
          downloadExcel(response.data.result);
        } else if (response?.data?.result?.file_category == "download_pdf") {
          setOpenPdfFile((data) => {
            return { ...data, open: false };
          });
          sendJsonAndDownloadPdf(response.data.result);
        } else {
          setOpenPdfFile((data) => {
            return { ...data, open: false };
          });
          setOpenXlfile((dt) => {
            return { open: false };
          });
        }
      })
      .catch((error) => {
        setOpenXlfile((dt) => {
          return { open: false };
        });
        setOpenPdfFile((data) => {
          return { ...data, open: false };
        });
      });
  };
  useEffect(() => {
    if (userData) {
      const { role_id } = userData;
      cardData = getCardData(role_id, t);
    }
  }, [userData, cardData]);
  useEffect(() => {
    if (customFilter != null) {
      //getPdfFilesData()
    }
  }, [customFilter]);

  return (
    <Box sx={{ padding: 3, backgroundColor: "#f5f6fa" }}>
      <Loading open={loading} />
      <CardLayout
        margin="10px 0px"
        cardContent={
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingBottom: "5px",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#252525", fontSize: "18px", fontWeight: 600 }}
              >
                {userData.role_id === 1
                  ? t("ticketsOverview")
                  : "Tickets Overview"}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#0FA5D8",
                  fontSize: "18px",

                  display:
                    userData && (userData.role_id == 2 || userData.role_id == 1)
                      ? "block"
                      : "none",
                }}
              >
                <Link
                  underline="always"
                  sx={{ cursor: "pointer" }}
                  onClick={handleCreateTicket}
                >
                  {userData.role_id === 1 ? t("createTicket") : "Create Ticket"}
                </Link>
              </Typography>
            </div>
            <Grid container spacing={2} alignItems="center" sx={{ mb: 4 }}>
              {/* Left Arrow */}
              <Grid
                item
                xs={0.5}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Tooltip
                  title="Previous"
                  style={{ backgroundColor: "white", color: "black" }}
                >
                  <KeyboardDoubleArrowLeftIcon
                    onClick={cardPage === 0 ? null : handlePrev}
                    style={{
                      cursor: cardPage === 0 ? "not-allowed" : "pointer",
                      color: cardPage === 0 ? "gray" : "#668cff",
                      fontSize: "2rem",
                    }}
                  />
                </Tooltip>
              </Grid>

              {/* Cards */}
              <Grid item xs={11}>
                <Grid container spacing={3}>
                  {data &&
                    data.length > 0 &&
                    data
                      .slice(cardPage, cardPage + itemsPerPage)
                      .map((item, index) => (
                        <Grid
                          item
                          xs={11}
                          sm={5}
                          md={data.length === 4 ? 3 : 3}
                          lg={data.length === 4 ? 3 : 3}
                          key={index}
                        >
                          <Paper
                            elevation={
                              hover && selectedCard === item.status
                                ? 6
                                : selectedCard === item.status
                                  ? 6
                                  : 1
                            }
                            onMouseEnter={() => {
                              if (selectedCard === item.status) {
                                setHover(true);
                              }
                            }}
                            onMouseLeave={() => {
                              if (selectedCard === item.status) {
                                setHover(false);
                              }
                            }}
                            onClick={(e) => {
                              handleCardData(e, item);
                            }}
                            sx={{
                              padding: 3,
                              backgroundColor: item.bg,
                              borderRadius: "10px",
                              cursor: "pointer",
                              justifyContent: "space-between",
                              height: '50px', // Add a fixed height (adjust as needed)
                              overflow: 'hidden', // Optional: Handle overflow

                              ":hover": {
                                backgroundColor: `#99ccff`,
                              },
                            }}
                          >
                            <Typography variant="h6" sx={{ color: "#01083A" }}>
                              {item.count}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 600, color: "#01083A" }}
                            >
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div>
                                  {item.label}
                                </div>
                                <div>
                                  {item.icon && (
                                    <div>
                                      <Tooltip
                                        title={
                                          <React.Fragment>
                                            <Typography variant="body2">{userData.role_id === 1
                                              ? t("infoLine1")
                                              : "Tickets will be displayed upto yesterday"}</Typography>
                                            <Typography variant="body2">{userData.role_id === 1
                                              ? t("infoLine2")
                                              : "Note:This count is not related to the total number of tickets"}</Typography>
                                          </React.Fragment>
                                        }
                                      >
                                        {item.icon}
                                      </Tooltip>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Typography>
                          </Paper>
                        </Grid>
                      ))}
                </Grid>
              </Grid>

              {/* Right Arrow */}
              <Grid
                item
                xs={0.5}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Tooltip
                  title="Next"
                  sx={{ backgroundColor: "white", color: "black" }}
                >
                  <KeyboardDoubleArrowRightIcon
                    onClick={
                      cardPage + itemsPerPage >= data.length ? null : handleNext
                    }
                    style={{
                      cursor:
                        cardPage + itemsPerPage >= data.length
                          ? "not-allowed"
                          : "pointer",
                      color:
                        cardPage + itemsPerPage >= data.length
                          ? "gray"
                          : "#668cff",
                      fontSize: "2rem",
                    }}
                  />
                </Tooltip>
              </Grid>
            </Grid>
          </div>
        }
      />

      {/* Create Ticket Buttons */}
      <CardLayout
        cardContent={
          <div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",

                gap: 1,

                bgcolor: "white",
                alignItems: "center",
              }}
            >
              <IconButton onClick={handleClick}>
                <CalendarMonthIcon />
              </IconButton>
              <Popover
                id="date-picker-popover"
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose1}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                sx={{
                  "& .MuiPaper-root": {
                    boxShadow: "none", // Removes the shadow
                  },
                }}
              >
                <Box p={2} display="flex" flexDirection="column" gap={2}>
                  <DateRangePicker
                    open={open}
                    toggle={handleClose1}
                    onChange={(range) => handleDateChange(range)}
                    value={selectedRange}
                  />

                  <Box display="flex" justifyContent="flex-end" gap={1}>
                    <Button onClick={handleClose1} variant="outlined">
                      Cancel
                    </Button>
                    <Button onClick={handleReset} variant="outlined">
                      Reset
                    </Button>
                    <Button onClick={handleSave} variant="contained">
                      Apply
                    </Button>
                  </Box>
                </Box>
              </Popover>
              {openPdfFile.open && (
                <img
                  src={loadergif}
                  style={{ cursor: "pointer", width: "18px" }}
                />
              )}

              {!openPdfFile.open && (
                <img
                  src={PdfIcon}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (isDownloadRequired) {
                      setOpenPdfFile((data) => {
                        return { ...data, open: true };
                      });
                      ////downloadExcel(response.data.result); sendJsonAndDownloadPdf
                      getPdfFilesData("download_pdf");
                      setOpenPdfFile((data) => {
                        return { ...data, open: true };
                      });
                    } else {
                      ShowAlert({
                        icon: "error",
                        text: "No Data Found",
                      });
                    }
                  }}
                />
              )}

              {openXlfile.open && (
                <img
                  src={loadergif}
                  style={{ cursor: "pointer", width: "18px" }}
                />
              )}
              {!openXlfile.open && (
                <img
                  src={ExcelIcon}
                  style={{ cursor: "pointer", width: "18px" }}
                  onClick={() => {
                    if (isDownloadRequired) {
                      setOpenXlfile((dt) => {
                        return { open: true };
                      });
                      //downloadExcel(response.data.result); sendJsonAndDownloadPdf
                      getPdfFilesData("download_excel");
                    } else {
                      ShowAlert({
                        icon: "error",
                        text: "No Data Found",
                      });
                    }
                  }}
                />
              )}
              {userData.role_id === 11 && (
                <CustomSelect
                  name="state"
                  control={control}
                  listItems={stateData}
                  defaultValue=""
                  placeholder="Select"
                  keyValue="state_id"
                  displayValue="state_name"
                  height="45px"
                  width="100%"
                  inputRef={register("state", {
                    required: false,
                  })}
                  handleChange={(e) => {
                    handleStateFilter({ id: e.target.value });
                  }}
                />
              )}
              <Input
                startAdornment={true}
                searchIcon={true}
                name="search"
                height="40px"
                placeholder="Search"
                inputRef={register("search", {
                  required: true,
                  onChange: (e) => handleSearch(e),
                })}
              />
            </Box>
            <CommonTable
              queryString={""}
              paginationData={paginationData}
              loadedFrom={"Country"}
              apiEndpoint={ticketListData}
              searchKey={"search"}
              searchValue={searchValue}
              filter_data={filters}
              colsData={columns}
              getRowData={handleRowClick}
              paginationRequired={props.hide ? false : true}
              statusName="countryStatus"
              setIsDownloadRequired={setIsDownloadRequired}
              hide={props.hide}
              noDataMessage="No Tickets Available"
              setPaginationData={setPaginationData}
              setTableData={setTableData}
              setCustomFilter={setCustomFilter}
              setDashboardData={setDashboardData}
              render={render}
            />
          </div>
        }
      />
      <CustomModal
        modalContent={
          <div>
            <TicketHistory
              rowData={rowData}
              userData={userData}
              handleClose={handleClose}
            />
          </div>
        }
        open={detailsOpen}
        handleClose={handleClose}
        modalTitleRequired={true}
        modalTitle={
          <div style={{ display: "flex", textAlign: "center" }}>
            <div style={{ textTransform: "capitalize", fontSize: "20px" }}>
              ticket Id:{""}{" "}
              <span style={{ color: "#0FA5D9" }}>{rowData.tckt_id}</span>
            </div>
            <div
              style={{
                marginLeft: "30px",
                padding: "5px",
                borderRadius: "5px",
                ...getTicketStyles(rowData.tckt_status), // Apply the returned styles
              }}
            >
              {rowData && rowData.status_dec}
            </div>
          </div>
        }
      />
      <Snackbar
        // anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
        message={snackBarMessage}
        sx={{
          "& .MuiSnackbarContent-root": {
            backgroundColor: "#fce6e2",
            color: "#504f4f",
          },
        }}
      />
    </Box>
  );
}

export default Dashboard;
